// Esportazione di una lista in CSV, Excel (.xlsx) o PDF.
//
// colonne: [{ label, valore: (riga) => testo|numero, larghezza?: caratteri (Excel), align?: 'left'|'center'|'right',
//             colore?: (riga) => [r, g, b] (colore del testo in PDF) }]
// Le librerie pesanti (xlsx, jspdf) si caricano solo al momento dell'esportazione.

const oggi = () => new Date().toISOString().slice(0, 10);

const celle = (colonne, righe) => righe.map((r) => colonne.map((c) => {
  const v = c.valore(r);
  return v === undefined || v === null ? '' : v;
}));

const scarica = (blob, nomeFile) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nomeFile;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const esportaCSV = ({ nomeFile, colonne, righe }) => {
  const intestazione = colonne.map((c) => c.label);
  const corpo = celle(colonne, righe);
  const csv = [intestazione, ...corpo]
    .map((riga) => riga.map((v) => `"${String(v).replace(/"/g, '""')}"`).join(','))
    .join('\n');
  // BOM: Excel apre correttamente gli accenti
  scarica(new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' }), `${nomeFile}_${oggi()}.csv`);
};

export const esportaXLSX = async ({ nomeFile, nomeFoglio = 'Export', colonne, righe }) => {
  const XLSX = await import('xlsx');
  const foglio = XLSX.utils.aoa_to_sheet([colonne.map((c) => c.label), ...celle(colonne, righe)]);
  foglio['!cols'] = colonne.map((c) => ({ wch: c.larghezza || 16 }));
  const libro = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(libro, foglio, nomeFoglio.slice(0, 31));
  XLSX.writeFile(libro, `${nomeFile}_${oggi()}.xlsx`);
};

export const esportaPDF = async ({ nomeFile, titolo, sottotitolo, colonne, righe }) => {
  const [{ jsPDF }, autoTableModulo] = await Promise.all([import('jspdf'), import('jspdf-autotable')]);
  const autoTable = autoTableModulo.default;

  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const ora = new Date().toLocaleString('it-IT');

  doc.setFontSize(22);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(15, 23, 42);
  doc.text('ORIZONDESK', 14, 20);

  doc.setFontSize(14);
  doc.setTextColor(100);
  doc.text(titolo, 14, 28);

  doc.setFontSize(9);
  doc.text(`Righe: ${righe.length}  |  Data report: ${ora}`, 14, 34);
  let inizioY = 40;
  if (sottotitolo) {
    doc.setFontSize(8);
    doc.text(sottotitolo, 14, 39, { maxWidth: 270 });
    inizioY = 45;
  }

  autoTable(doc, {
    startY: inizioY,
    head: [colonne.map((c) => c.label)],
    body: celle(colonne, righe),
    theme: 'striped',
    headStyles: { fillColor: [15, 23, 42], fontSize: 9, fontStyle: 'bold', halign: 'center' },
    styles: { fontSize: 8, cellPadding: 3, overflow: 'linebreak' },
    columnStyles: Object.fromEntries(colonne.map((c, i) => [i, { halign: c.align || 'left' }])),
    didParseCell: (dati) => {
      if (dati.section !== 'body') return;
      const colore = colonne[dati.column.index]?.colore;
      if (colore) {
        const rgb = colore(righe[dati.row.index]);
        if (rgb) {
          dati.cell.styles.textColor = rgb;
          dati.cell.styles.fontStyle = 'bold';
        }
      }
    },
    didDrawPage: () => {
      const pagina = doc.internal.pageSize;
      const larghezza = pagina.width || pagina.getWidth();
      const altezza = pagina.height || pagina.getHeight();
      doc.setFontSize(8);
      doc.setTextColor(150);
      doc.setFont('helvetica', 'normal');
      doc.text(`Report generato il: ${ora}`, 14, altezza - 10);
      doc.text(`OrizonDesk - Pagina ${doc.internal.getNumberOfPages()}`, larghezza / 2, altezza - 10, { align: 'center' });
      doc.text('https://desk.orizon-aix.com', larghezza - 14, altezza - 10, { align: 'right' });
    },
  });

  doc.save(`${nomeFile}_${oggi()}.pdf`);
};
